import { generatePath, Navigate, useParams } from 'react-router-dom';

/**
 * Redirects to a new path with the given parameters.
 * @param to - The path to redirect to.
 * @param paramKeys - The keys of the parameters to include in the new path.
 * @returns A redirect component.
 */
export function RedirectWithParams({
  to,
  paramKeys,
}: {
  to: string;
  paramKeys: string[];
}) {
  const params = useParams();
  const redirectParams = paramKeys.reduce(
    (acc, key) => {
      if (params[key]) {
        acc[key] = params[key];
      }
      return acc;
    },
    {} as Record<string, string>,
  );
  return <Navigate to={generatePath(to, redirectParams)} replace />;
}
